import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'mc2010',
    ecrans: [
        '00-2'
    ]
});
